<div>
    <app-customer-feed-back-master-form></app-customer-feed-back-master-form>
</div>
<div>
    <app-customer-feed-back-master-list></app-customer-feed-back-master-list>
</div>